


































































helpers = require('../../../helpers.coffee')

view_model =
  components:
    triggerStages: require './trigger_stages.vue'
    propertiesMatching: require './properties_matching.vue'

  data: ->
    current_user: Session.current_user
    salesforce_authorized: Session.current_user.salesforce_setting?.access_token?
    salesforce_setting: if Session.current_user.salesforce_setting.id? then Session.current_user.salesforce_setting else new SalesforceSetting()
    matching: []
    api_fields: []
    permission_groups: true
    api_permissions: true
    only_lead: false
    leads_and_accounts: false
    leads_accounts_and_opportunities: false

  computed:
    to_article: ->
      'https://suporte.reev.co/articles/2619495-como-fazer-a-integracao-do-reev-com-o-salesforce'

    salesforce_mark_as: ->
      @salesforce_setting.mark_as == 'lead_and_opportunity'

    salesforce_send_to: ->
      @salesforce_setting.send_to == 'queue'

    salesforceSandboxTeste:->
      if @salesforce_setting.sandbox_test
        return this.$t('integrations.checkbox.sandboxEnv')
      else
        return this.$t('integrations.checkbox.productionEnv')

    salesforceOauthUrl: ->
      client_id = if Session.current_user.new_ui then process.env.SALESFORCE_BETA_CLIENT_ID else process.env.SALESFORCE_CLIENT_ID

      params = jQuery.param(
        client_id: client_id
        response_type: 'code'
        redirect_uri: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'salesforce,'+@salesforce_setting.sandbox_test
      )
      if @salesforce_setting.sandbox_test
        "https://test.salesforce.com/services/oauth2/authorize?#{params}"
      else
        "https://login.salesforce.com/services/oauth2/authorize?#{params}"

  methods:
    sending_checked: (option) ->
      @only_lead = @leads_and_accounts = @leads_accounts_and_opportunities = false

      @only_lead = true if option == 'lead'
      @leads_and_accounts = true if option == 'lead_account'
      @leads_accounts_and_opportunities = true if option == 'lead_account_opportunity'

    toggleSalesforceMarkAs: ->
      if @salesforce_setting.mark_as == 'lead_and_opportunity'
        @salesforce_setting.mark_as = 'only_lead'
      else
        @salesforce_setting.mark_as = 'lead_and_opportunity'

    toggleSalesforceSendTo: ->
      return if !@permission_groups
      if @salesforce_setting.send_to == 'responsible'
        @salesforce_setting.send_to = 'queue'
      else
        @salesforce_setting.send_to = 'responsible'

    updateSalesforceSetting: ->
      Loader.on()
      mark_as = 'only_lead' if @only_lead
      mark_as = 'lead_and_account' if @leads_and_accounts
      mark_as = 'lead_account_and_opportunity' if @leads_accounts_and_opportunities

      params = {
        id: Session.current_user.id,
        salesforce_setting_attributes: {
          id: @salesforce_setting.id,
          mark_as: mark_as,
          send_to: @salesforce_setting.send_to,
          triggers: @salesforce_setting.triggers,
          properties_matching: @matching
        }
      }
      new UsersResource().update(@updateSalesforceSettingSuccess, @handleApiErrors, params)

    updateSalesforceSettingSuccess: (data, response) ->
      Loader.off()
      alertify.success this.$t('general.feedback.settingUpdated')
      Session.signIn(response.body.user)
      @current_user = Session.current_user

    saveSalesforceSetting: ->
      @updateSalesforceSetting()

    redirectToSalesforceOauthUrl: ->
      if @salesforce_authorized
        Loader.on()
        params = {
          id: Session.current_user.id,
          salesforce_setting_attributes: {
            id: @salesforce_setting.id,
            _destroy: 1
          }
        }
        new UsersResource().update(@updateSalesforceSettingSuccess, @handleApiErrors, params)
        @salesforce_authorized = false
        alertify.success this.$t('integrations.feedback.salesforceDisconnectSuccess')
        intercom_event_name = this.$t('integrations.feedback.salesforceDisconnectEvent')
        IntercomCtrl.trackEvent(intercom_event_name)
      else
        Loader.on()
        return window.parent.postMessage({ type: "redirect-integration", route: @salesforceOauthUrl }, "*") if window.parent && Session.current_user.new_ui
        window.location = @salesforceOauthUrl

    authorizeSalesforce: ->
      Loader.on()
      code = @$route.query.code
      @$router.replace(name: 'integrations')
      IntegrationsResource.authorize_salesforce(
        @authorizeSalesforceSuccess,
        @authorizeSalesforceFailure,
        code: code
        sandbox_test: Session.current_user.sandbox_test
      )
      EventsBus.$emit 'salesforce-account-connected'

    authorizeSalesforceSuccess: (response) ->
      Session.updateCurrentUser(response.body.user)
      @current_user = Session.current_user
      Loader.off()
      alertify.success(this.$t('integrations.feedback.salesforceConnectSuccess'))
      @salesforce_authorized = true
      intercom_event_name = this.$t('integrations.feedback.salesforceConnectEvent')
      IntercomCtrl.trackEvent(intercom_event_name)

    authorizeSalesforceFailure: (response) ->
      Loader.off()
      alertify.error(response.body.error, 10)

    setStages: (data) ->
      @salesforce_setting.triggers = data

    matchingUpdated: (data) ->
      @matching = data

    loadSalesforceFields: ->
      return if !@salesforce_setting.access_token

      @only_lead = true if @salesforce_setting.mark_as == 'only_lead'
      @leads_and_accounts = true if @salesforce_setting.mark_as == 'lead_and_account'
      @leads_accounts_and_opportunities = true if @salesforce_setting.mark_as == 'lead_account_and_opportunity'

      opts = {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }

      self = @
      Vue.http.get("#{process.env.API_URL}/salesforces/contact_properties", opts)
        .then((response) ->
          fields = response.body.map((field) -> { name: field.label, key: field.name, type: 'input', updateable: field.updateable, required: !field.nillable })
          self.api_fields = fields.filter (field) -> field.updateable && ['LastName', 'FirstName', 'Company', 'Email', 'OwnerId', 'IsUnreadByOwner'].indexOf(field.key) == -1
          self.api_permissions = true
        )
        .catch((error) ->
          self.api_permissions = false
        )

    validateApiGroups: ->
      return if !@salesforce_setting.access_token

      opts = {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }

      self = @
      Vue.http.get("#{process.env.API_URL}/salesforces/validate_api_permissions", opts)
        .then((response) ->
          self.permission_groups = response.body
          self.salesforce_setting.send_to = 'responsible' if response.body == false
        )
        .catch((error) ->
          self.permission_groups = false
          self.salesforce_setting.send_to = 'responsible'
        )

  mounted: ->
    Tooltip.initialize()
    @loadSalesforceFields()
    @validateApiGroups()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/salesforce.vue